"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _styles = require("@material-ui/core/styles");
var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    root: {
      padding: '16px',
      borderColor: palette.secondary.light,
      color: palette.secondary.dark,
      '&:hover': {
        borderColor: palette.secondary.light
      }
    }
  };
}, {
  name: 'ActionButton'
});
exports.useStyles = useStyles;